import { Button, Typography } from "antd";
import React,{ useEffect, useRef, useState } from "react";

export const ShowMoreText = ({ text,lineNumber=4 }) => {
  const [expanded, setExpanded] = useState(false);
  const [isOverflow, setIsOverflow] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      const lineHeight = parseInt(
        window.getComputedStyle(textRef.current).lineHeight,
        10
      );
      const maxHeight = lineHeight * lineNumber; 
      if (textRef.current.scrollHeight > maxHeight) {
        setIsOverflow(true);
      }
    }
  }, [text]);

  return (
    <div>
      <div
        ref={textRef}
        style={{
          display: "-webkit-box",
          WebkitLineClamp: expanded ? "unset" : lineNumber,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {text}
      </div>
      {isOverflow && (
        <div style={{cursor:"pointer",color:"#0080cb"}} onClick={() => setExpanded(!expanded)}>
          {expanded ? "折りたたむ" : "続きを読む"}
        </div>
      )}
    </div>
  );
};
